<ng-container *ngIf="!isLoading else loading">
	<div class="card-title">
		<span translate>delivery-tracking.stock-per-mill</span>
	</div>
	<div class="mill-block">
		<button type="button" *ngFor="let batch of batchesAtMill;" class="mill-row"
		[class.copo-clickable]="batch.millRipple"
		[matRippleDisabled]="!batch.millRipple"
		(click)="viewDetails(batch.mill, batch.millDescription);" mat-ripple>
			<div class="mill-line-icon">
				<div class="icon-container">
					<mat-icon class="mill-icon mat-icon label-orange-color" role="img" svgIcon="at_consignment"></mat-icon>
				</div>
			</div>
			<span class="mill-line-label">{{ batch.millDescription }}</span>
			<span class="mill-line-tonnage">{{ getQtyBatch(batch) | copoNumber: 'weight-aggregate':'t'}}</span>
			<mat-icon class="mill-line-chevron" color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>
	</div>
	<div class="card-block-footer mobile-hide">
		<button type="button" mat-button color="primary" (click)="viewDetails()">
			<span translate>delivery-tracking.view-details</span>
			<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>
	</div>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
